import type React from "react"
import { tv } from "tailwind-variants"
import { classNames } from "../../utils/classNames"
import { FlexCenter, type FlexCenterProps } from "../FlexCenter"
import { textLabelVariants } from "../Text/TextLabel"

export type ChipProps = {
  children: React.ReactNode
  className?: string
  variant?: "default" | "frosted"
} & FlexCenterProps

const chipVariants = tv({
  base: "h-[18px] w-fit whitespace-nowrap rounded px-1.5 py-1",
  variants: {
    variant: {
      default: "border border-border-1 bg-bg-primary",
      frosted: "border border-frosted-3 bg-frosted-2",
    },
  },
})

export function Chip({
  children,
  className,
  variant = "default",
  ...rest
}: ChipProps) {
  return (
    <FlexCenter
      className={classNames(
        chipVariants({ variant }),
        textLabelVariants({ size: "xs" }),
        className,
      )}
      {...rest}
    >
      {children}
    </FlexCenter>
  )
}
